module.exports = __webpack_public_path__ + "img/1-bn.d77ae2eb.png";